import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Spinner } from 'react-bootstrap';
import { resetPagination } from '../../store/actions/commonActions';
import { fetchPosts, 
  filterPosts, 
  searchPosts,
  clearPosts,
  ANNOUNCEMENT,
  NEWS,
  RESET_POSTS_PAGINATION, 
  SET_POSTS_PAGINATION,
  DRAFT,
  PUBLISHED } from '../../store/actions/posts/postsActions';
import { capitalize } from '../../common/Utilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye } from '@fortawesome/free-solid-svg-icons';

import PageTitle from '../../common/PageTitle';
import ListPagination from '../../common/ListPagination';

class Posts extends Component {

  componentDidMount() {
    this.props.resetPagination(RESET_POSTS_PAGINATION);
    this.fetchPosts();
  }

  fetchPosts = (filters = null) => {
    this.props.clearPosts();

    if (filters) {
      Object.assign(filters, {post_type: [NEWS, ANNOUNCEMENT]});
    }
    else {
      filters = {post_type: [NEWS, ANNOUNCEMENT]}
    }
    console.log(filters);
    this.props.fetchPosts(filters);
  }

  filterPosts = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Search Posts" onChange={(e) => {
        const filter = e.target.value;

        if (this.delay) {
          clearTimeout(this.delay);
        }

        this.delay = setTimeout(() => {
          this.props.searchPosts(filter, (searchKeyword) => {
            console.log(searchKeyword);
            this.fetchPosts(searchKeyword)
          });
        }, 500)
      }} />
    )
  }

  renderPosts = () => {
    let posts = this.props.posts.posts;
    let postList = [];

    console.log(posts);
    if (posts) {
      postList = posts.length ? (
        posts.map((post, key) => {
          return (
            <tr key={key}>
              <td>{post.title}</td>
              <td className="align-center" width="10%">{capitalize(post.post_type.type_name)}</td>
              <td className="align-center" width="20%">{capitalize(post.status.name)}</td>
              <td className="align-center" width="20%">{post.app.name}</td>
              <td className="align-center" width="10%">{post.created_by.first_name+" "+post.created_by.last_name}</td>
              <td className="align-center" width="10%">{post.created_at}</td>
              <td className="align-center" width="10%">{post.updated_at}</td>
              <td className="align-center" width="20%">
                <div className="align-center action-btns">
                  { post.status.id === DRAFT && (
                    <Button size="sm" className="btn-icon ml-3" onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push('/posts/edit?id=' + post.id)
                    }}>
                      <FontAwesomeIcon icon={faPen} /> Edit 
                    </Button>
                  ) }
                  { post.status.id === PUBLISHED && (
                    <Button size="sm" className="btn-icon ml-3" onClick={(e) => {
                      e.preventDefault();
                      this.props.history.push('/posts/view?id=' + post.id)
                    }}>
                      <FontAwesomeIcon icon={faEye} /> View 
                    </Button>
                  ) }
                </div>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={4}><Spinner animation="border" size="sm" /></td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={4}><p className="text-danger">No posts found.</p></td>
        </tr>
      )
    }

    return postList;
  }

  render() {
    const addClient = <Button id="add-post" size="sm" onClick={() => {
      this.props.history.push('/posts/new')
    }}>Create New Post</Button>

    let listPagination = '';

    const posts = this?.props?.posts;

    if (!posts.postFilter) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination 
            dispatchType={SET_POSTS_PAGINATION}
            data={posts.clients} 
            min={posts.min}
            max={posts.max}
            currentPage={posts.currentPage} 
            totalPages={posts.totalPages} 
            fetchCallback={() => {
              this.fetchPosts();
            }}
            numItems={posts.totalItems} />
        </div>
      )
    }

    this.pathname = this.props.location.pathname;

    return (
      <Container className="waa-container container">
        <PageTitle pageName="Posts" actionButton={addClient} />
        <Row className="mb-3">
          <Col>
            <div className="float-right">
              {listPagination}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table
              className="waa-table table"
            >
              <thead>
                <tr>
                  <th className="align-center" width="20%">TITLE</th>
                  <th className="align-center" width="10%">TYPE</th>
                  <th className="align-center" width="10%">STATUS</th>
                  <th className="align-center" width="5%">APP</th>
                  <th className="align-center" width="20%">CREATED BY</th>
                  <th className="align-center" width="10%">CREATED ON</th>
                  <th className="align-center" width="10%">LAST UPDATE</th>
                  <th className="align-center" width="20%">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={9}>
                    { this.filterPosts() }
                  </td>
                </tr>
                { this.renderPosts() }
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToDispatch = (state) => ({
  posts: state.posts 
})

const mapDispatchToProps = (dispatch) => ({
  fetchPosts: (...args) => dispatch(fetchPosts(...args)),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  filterPosts: (...args) => dispatch(filterPosts(...args)),
  clearPosts: () => dispatch(clearPosts()),
  searchPosts: (...args) => dispatch(searchPosts(...args))
})

export default withRouter(connect(mapStateToDispatch, mapDispatchToProps)(Posts))
